import { blobticService } from '../../Commun/services/blobticService';
import { ComponentItem } from '../components/ComponentLibrary';

interface ComponentDto {
    CMP_IDF: number;
    CMP_UIDF?: string;
    CMP_CODE?: string;
    CMP_LIB: string;
    CMP_TYPE: string;
    CMP_NOTES?: string;
    CMP_UNIT_PRICE: number;
    CMP_QUANTITY: number;
    CMP_ICON?: string;
    MAT_LIB?: string; // Icon logic might need this or just map type to icon
    // Using CMP_TYPE as category ('hardware', 'shutter', etc.)
    // Using CMP_NOTES as description
    IS_LIBRARY?: number; // 1 or 0
}

const mapDtoToModel = (dto: ComponentDto): ComponentItem => {
    // Basic mapping. In a real scenario we might need better icon mapping.
    let icon = dto.CMP_ICON || '🔧';
    if (!dto.CMP_ICON) {
        if (dto.CMP_TYPE === 'shutter') icon = '🪟';
        if (dto.CMP_TYPE === 'screen') icon = '🕸️';
        if (dto.CMP_TYPE === 'roller') icon = '📦';
    }

    return {
        id: dto.CMP_IDF.toString(), // Frontend expects string ID
        name: dto.CMP_LIB,
        category: dto.CMP_TYPE as any,
        icon: icon,
        description: dto.CMP_NOTES || '',
        unitPrice: dto.CMP_UNIT_PRICE,
        defaultQuantity: dto.CMP_QUANTITY
    };
};

const mapModelToDto = (model: Partial<ComponentItem>): Partial<ComponentDto> => ({
    CMP_IDF: model.id ? parseInt(model.id) : 0,
    CMP_LIB: model.name,
    CMP_TYPE: model.category,
    CMP_NOTES: model.description,
    CMP_UNIT_PRICE: model.unitPrice,
    CMP_QUANTITY: model.defaultQuantity || 1,
    CMP_ICON: model.icon || '🔧'
});

export const componentsApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_component,Select',
                IS_LIBRARY: 1
            }
        });

        if (response.success && Array.isArray(response.data)) {
            return {
                data: response.data.map((item: any) => mapDtoToModel(item)),
                success: true
            };
        }
        return { data: [], success: false, message: response.message };
    },

    create: async (item: Omit<ComponentItem, 'id'>) => {
        const dto = mapModelToDto(item);
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_component,Insert',
                ...dto
            }
        });
        return { success: response.success, message: response.message };
    },

    update: async (item: ComponentItem) => {
        const dto = mapModelToDto(item);
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_component,Update',
                ...dto
            }
        });
        return { success: response.success, message: response.message };
    },

    delete: async (id: string) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_component,Delete',
                CMP_IDF: parseInt(id)
            }
        });
        return { success: response.success, message: response.message };
    }
};
